import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';

import { MainLayoutComponent } from "./layouts/main-layout/main-layout.component";

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: true,
    imports: [RouterModule, MainLayoutComponent]
})
export class AppComponent {
}
